/**
 * plugins/vuetify.js
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
//import '@mdi/font/css/materialdesignicons.css'
import "vuetify/styles";

// Composables
import { createVuetify } from "vuetify";
import { aliases, mdi } from "vuetify/iconsets/mdi-svg";
import {
  mdiAccount,
  mdiAccountCircle,
  mdiAccountGroup,
  mdiAccountSchool,
  mdiAccountTie,
  mdiAlert,
  mdiBank,
  mdiBrain,
  mdiCalculator,
  mdiCalendarRange,
  mdiCalculatorVariant,
  mdiChatProcessing,
  mdiChartAreaspline,
  mdiChartLine,
  mdiChartLineVariant,
  mdiChartTimeline,
  mdiChartTimelineVariant,
  mdiChartPie,
  mdiCheckCircle,
  mdiChevronDoubleLeft,
  mdiChevronDoubleRight,
  mdiChevronDown,
  mdiChevronRight,
  mdiCircle,
  mdiClose,
  mdiCommentText,
  mdiCompare,
  mdiCalendar,
  mdiCounter,
  mdiCreditCardOutline,
  mdiCurrencyInr,
  mdiCurrencyRupee,
  mdiDelete,
  mdiDipSwitch,
  mdiEmail,
  mdiFinance,
  mdiFilter,
  mdiHome,
  mdiDotsHorizontal,
  mdiFolder,
  mdiGoogle,
  mdiInformationOutline,
  mdiLightningBolt,
  mdiLogout,
  mdiMagnify,
  mdiMenu,
  mdiMessageDraw,
  mdiMessageText,
  mdiMicrophone,
  mdiMinus,
  mdiPlus,
  mdiRobotExcited,
  mdiSend,
  mdiShieldCheck,
  mdiSignalCellularOutline,
  mdiSquareEditOutline,
  mdiStrategy,
  mdiTrashCan,
  mdiTrendingUp,
  mdiTwitter,
  mdiWallet,
} from "@mdi/js";

export default createVuetify({
  icons: {
    defaultSet: "mdi",
    aliases: {
      ...aliases,
      mdiAccount,
      mdiAccountCircle,
      mdiAccountGroup,
      mdiAccountSchool,
      mdiAccountTie,
      mdiAlert,
      mdiBank,
      mdiBrain,
      mdiCalculator,
      mdiCalculatorVariant,
      mdiChatProcessing,
      mdiChartAreaspline,
      mdiChartLine,
      mdiChartLineVariant,
      mdiChartTimeline,
      mdiChartTimelineVariant,
      mdiChartPie,
      mdiCheckCircle,
      mdiChevronDoubleLeft,
      mdiChevronDoubleRight,
      mdiChevronDown,
      mdiChevronRight,
      mdiCircle,
      mdiClose,
      mdiCommentText,
      mdiCompare,
      mdiCalendar,
      mdiCalendarRange,
      mdiCounter,
      mdiCreditCardOutline,
      mdiCurrencyInr,
      mdiCurrencyRupee,
      mdiDelete,
      mdiDipSwitch,
      mdiEmail,
      mdiFilter,
      mdiFinance,
      mdiHome,
      mdiDotsHorizontal,
      mdiFolder,
      mdiGoogle,
      mdiInformationOutline,
      mdiLightningBolt,
      mdiLogout,
      mdiMagnify,
      mdiMenu,
      mdiMessageDraw,
      mdiMessageText,
      mdiMicrophone,
      mdiMinus,
      mdiPlus,
      mdiRobotExcited,
      mdiSend,
      mdiShieldCheck,
      mdiSignalCellularOutline,
      mdiSquareEditOutline,
      mdiStrategy,
      mdiTrashCan,
      mdiTrendingUp,
      mdiTwitter,
      mdiWallet,
    },
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: "light",
  },
});
